import { TieredMenu } from "primereact/tieredmenu";
import { useCallback } from "react";
import { IconDispatcher } from "shared/Icons";
import '../editor.scss';

export const TextAlignOptions = ({ editor, textAlignRef,handleshow }) => {
  const handleClick = useCallback((arg, e) => {
    e && e.preventDefault()
    editor.chain().focus().setTextAlign(arg).run();
    handleshow(e, 'textAlign')
  }, [editor,handleshow])

  const isActive = useCallback((type, att) => {
    if (att) return editor.isActive(type, att) ? 'is-active' : ''
    return editor.isActive(type) ? 'is-active' : ''
  }, [editor])
  const iconActive = useCallback(() => {
    if (isActive({ textAlign: 'left' })) return 'align-left'
    if (isActive({ textAlign: 'center' })) return 'align-center'
    if (isActive({ textAlign: 'right' })) return 'align-right'
    if (isActive({ textAlign: 'justify' })) return 'align-justify'

    return 'align-left'

  }, [isActive])

  if (!editor) {
    return null
  }

  const items = [
    { label: "Align left", value: "left", icon: 'align-left', text: 'Align left', attribute: { textAlign: 'left' } },
    { label: "Align center", value: "center", icon: 'align-center', text: 'Align center', attribute: { textAlign: 'center' } },
    { label: "Align right", value: "right", icon: 'align-right', text: 'Align right', attribute: { textAlign: 'right' } },
    { label: "Justify", value: "justify", icon: 'align-justify', text: 'Align justify', attribute: { textAlign: 'justify' } },
  ];


  const templates = items.map(item => (item.separator ? item : {
    template: (
      <div key={item.label} onClick={(e) => handleClick(item.value, e)} className={isActive(item.attribute) + ' pointer p-2 px-4'}  style={{ minWidth: '200px' }}
>
        {IconDispatcher(item.icon, "me-2", { family: 'sharp' })} {item.text}
      </div>
    )
  }));

  const icon = iconActive()
  return (
    <>
      <TieredMenu model={templates} popup ref={textAlignRef} breakpoint="767px" className='menu-color-toolbar '  />
      <button key={icon}  title="Alignment" className={(isActive('paragraph') || isActive('heading')) + " d-flex justify-content-center align-items-center"} onClick={(e) => {
        e.preventDefault()
        handleshow(e, 'textAlign')
      }} >
        {IconDispatcher(icon, "", { family: 'sharp' })} {IconDispatcher('angle-down', "ms-1", { size: "sm" })}</button>
    </>
  );

};